const cartQuantity = (products) => {
    document.querySelectorAll('.js-thumb.is-in-cart').forEach(thumb => {
        thumb.classList.remove('is-in-cart')
    })

    document.querySelectorAll('.js-in-cart-ribbon').forEach(thumb => {
        thumb.classList.add('hidden')
    })

    if (!products) {
        return
    }

    const productsInCartPrices = {};

    for (const product of Object.values(products)) {
        if (typeof productsInCartPrices[product.id] === 'undefined') {
            productsInCartPrices[product.id] = 0
        }

        // TODO: tu mozno uz z BE natahovat final_price, lebo mozno nemusia vzdy sediet centy
        productsInCartPrices[product.id] += product.quantity * product['price' + (window.Eshop.options.pricesWithVat ? '_vat' : '')]
    }

    for (const productCartId in productsInCartPrices) {
        const productPrice = productsInCartPrices[productCartId]

        document.querySelectorAll(`.js-thumb[data-product-cart-id="${productCartId}"]`).forEach(thumb => {
            thumb.classList.add('is-in-cart')
        })

        document.querySelectorAll(`.js-in-cart-ribbon[data-product-cart-id="${productCartId}"]`).forEach(ribbon => {
            ribbon.classList.remove('hidden')
            ribbon.querySelector('.sc-price').innerHTML = Format.price(productPrice)
        })
    }
}

Event.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return
    }

    cartQuantity(response.products)
})

Event.on('Cart.product.removed', function (data) {
    if (!data || !data.status || !data.products) {
        return
    }

    cartQuantity(data.products)
})

Event.on('Cart.fetchedProducts', function (data) {
    if (!data) {
        return
    }

    const response = data.response

    if (!response || !response.status || !response.data) {
        return
    }

    cartQuantity(response.data.items)
})